<template>
    <app-state
        v-if="entityState"
        :state="entityState"
        :title="entityState === 'not-found' ? 'Документ не найден' : 'Не удалось загрузить документ'"
        :message="entityMessage"
        :action-to="{ name: 'documents_list' }"
    />
    <div v-else class="document-edit-route">
        <div class="document-edit-route__main">
            <router-view />
        </div>
        <div class="document-edit-route__history">
            <q-list>
                <q-item-label header>История исправлений</q-item-label>

                <q-item v-for="item in changes" v-bind:key="item.id">
                    <q-item-section>
                        <q-item-label>Кем: {{ item.user }}</q-item-label>
                        <q-item-label caption>Когда: {{ item.date }}</q-item-label>
                        <q-item-label caption>{{ item.message }}</q-item-label>
                        <q-item-label caption><q-btn icon="save" label="Переключиться" dense flat /></q-item-label>

                    </q-item-section>
                </q-item>
            </q-list>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import moment from "moment";
import AppState from '../../../components/ui/AppState.vue'

export default {
    name: "document_edit_root",
    components: { AppState },
    data() {
        this.emitter.on('didReceiveDocumentInfoShort', (data) => {
            // const changes = response.data.changes;
            console.log(data.body);
            this.name = data.data.name;
            this.changes = data.data.changes;
            this.transfers = data.data.transfers;
        });
        this.emitter.on('onCreateDocumentTransfer', (data) => {
            console.log(data);
            this.transfers = data.data.transfers;
        });
        this.emitter.on('didReceiveBillListFlatCompact', (data) => {
            this.bills_list = (Array.isArray(data.bills) ? data.bills : []).map((element) => {
                return { label: element.full_name, value: element.id }
            });
        });
        this.emitter.on('onDocumentInfoError', this.setEntityError);
        this.emitter.on('onDocumentInfoShortError', this.setEntityError);
        if (this.connection.isAuthenticated) {
            this.connection.getDocumentInfoShort(
                '1',
                this.$route.params.id
            );
            this.connection.gitBillsListFlatCompact(
                '1'
            );
        } else {
            this.emitter.on('connectionReady', () => {
                this.connection.getDocumentInfoShort(
                    '1',
                    this.$route.params.id
                );
                this.connection.gitBillsListFlatCompact(
                    '1'
                );
            })
        }
        return {
            name: ref(''),
            transfers: ref([]),
            changes: ref([]),
            document_id: ref(this.$route.params.id),
            bills_list: ref([]),
            wildcard_summ: ref(null),
            wildcard_name: ref(null),
            wildcard_comment: ref(null),
            wildcard_bill_from: ref(null),
            wildcard_bill_to: ref(null),
            entityState: ref(null),
            entityMessage: ref('')
        }
    },
    beforeUnmount() {
        this.emitter.off('onDocumentInfoError', this.setEntityError);
        this.emitter.off('onDocumentInfoShortError', this.setEntityError);
    },
    methods: {
        setEntityError(error) {
            this.entityState = error.state || 'error';
            this.entityMessage = error.message || 'Попробуйте вернуться к списку документов';
        },
        onTransferStateChange(value, item_id) {
            this.connection.updateTransferStatus(
				'1',
				item_id,
				value ? 'posted' : 'draft'
			)
        },
        onTransferBillChange(value, item_id, direction) {
            this.connection.updateTransferAccounts(
				'1',
				item_id,
				direction === 'from' ? { credit_account_id: value } : { debit_account_id: value }
			)
        },
        formatDate(date) {
            return moment.unix(date).format('DD.MM.YYYY');
        },
        createTransferWildcard() {
            this.$q.loading.show();
            this.connection.createDocumentTransfer(
				'1',
				{
					document_id: this.$route.params.id,
					amount: this.wildcard_summ,
					name: this.wildcard_name,
					comment: this.wildcard_comment,
					credit_account_id: this.wildcard_bill_from.value,
					debit_account_id: this.wildcard_bill_to.value
				}
			)
        },
    }
}
</script>

<style scoped>
.document-edit-route {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
    gap: 16px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: hidden;
    box-sizing: border-box;
}

.document-edit-route__main,
.document-edit-route__history {
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
}

@media (max-width: 1439px) {
    .document-edit-route {
        grid-template-columns: minmax(0, 1fr);
    }
}
</style>
